import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import WhiteSpaceChartCategoryItem from "./WhiteSpaceChartCategoryItem";
import WhiteSpaceSummary from "./WhiteSpaceSummary";

const WhiteSpaceChartContainer = React.forwardRef(({
    showZeroInChart,
    setDisabledDownload = () => {}
}, ref) => {
    const { generateGrid } = useSelector((state) => state.reports);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setDisabledDownload(false);
        }, generateGrid.length * 1000);
        return () => {
            if (timeout) clearTimeout(timeout);
        };
    }, [generateGrid]);

    return (
        <div
            style={{
                width: "100%",
                height: "calc(100% - 10mm)",
                overflowY: "auto"
            }}
            ref={ref}
        >
            {
                [...generateGrid].map((category, idx) => (
                    <WhiteSpaceChartCategoryItem
                        key={category.key}
                        category={category}
                        idx={idx}
                        showZeroInChart={showZeroInChart}
                    />
                ))
            }
            <WhiteSpaceSummary
                key="summary"
                showZeroInChart={showZeroInChart}
            />
        </div>
    );
});

export default WhiteSpaceChartContainer;
